import { __makeTemplateObject } from "tslib";
// @flow
import * as React from 'react';
import { m } from 'framer-motion';
import styled from 'styled-components';
var sizes = {
    xlarge: '24px',
    large: '20px',
    default: '16px',
    small: '14px',
    xsmall: '10px'
};
var IconWrapper = styled(m.div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  text-align: center;\n  padding: 2px;\n  overflow: hidden;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  text-align: center;\n  padding: 2px;\n  overflow: hidden;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n"])), function (_a) {
    var size = _a.size;
    return sizes[size];
}, function (_a) {
    var size = _a.size;
    return sizes[size];
});
var ReactTreeIconContainer = styled(IconWrapper)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  svg {\n    height: 100%;\n    width: 100%;\n\n    * {\n      fill: ", ";\n      stroke: ", ";\n    }\n  }\n"], ["\n  svg {\n    height: 100%;\n    width: 100%;\n\n    * {\n      fill: ", ";\n      stroke: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme, currentTheme = _a.currentTheme;
    return "" + theme._themes[currentTheme || 'dark'].icon;
}, function (_a) {
    var theme = _a.theme, currentTheme = _a.currentTheme;
    return "" + theme._themes[currentTheme || 'dark'].icon;
});
var Icon = React.forwardRef(function (_a, ref) {
    var _b = _a.size, size = _b === void 0 ? 'default' : _b, _c = _a.currentTheme, currentTheme = _c === void 0 ? 'dark' : _c, _d = _a.defaultIcon, defaultIcon = _d === void 0 ? false : _d, children = _a.children;
    return defaultIcon ? (React.createElement(ReactTreeIconContainer, { ref: ref, currentTheme: currentTheme, size: size }, children)) : (React.createElement(IconWrapper, { ref: ref, size: size }, children));
});
var MotionIcon = m(Icon, { forwardMotionProps: true });
export default MotionIcon;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Icon.js.map